import styled from 'styled-components'

import { Button as ButtonElement } from '@interco/inter-ui/components/Button'

import { fadeIn } from './animations'

type PageContentProps = {
  orientation?: 'VERTICAL' | 'HORIZONTAL'
  padding?:
    | { top?: string; right?: string; bottom?: string; left?: string }
    | { topBottom?: string; leftRight?: string }
    | { all: string }
  gap?: number
}

type PageBottomContentProps = {
  $padding?: number
}

export const Page = styled.div`
  color: var(--typography500);
  background-color: var(--neutral-theme);
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  max-width: 100vw;
  animation: ${fadeIn} 0.3s linear;
`

export const PageContent = styled.div<PageContentProps>`
  max-height: 100vh;
  max-width: 100vw;
  touch-action: pan-y;
  overflow-y: auto;
  user-select: none;
  -webkit-user-drag: none;
  color: var(--typography500);
  background-color: var(--neutral-theme);
  display: flex;
  flex: 1;
  flex-direction: ${({ orientation }) =>
    orientation && orientation === 'HORIZONTAL' ? 'row' : 'column'};
  padding: ${({ padding }) => {
    if (typeof padding === 'object') {
      return Object.values(padding).join(' ')
    }

    return '0rem 1.25rem 1rem 1.25rem'
  }};
  gap: ${({ gap }) => (gap ? `${gap}px` : 'normal')};

  a {
    text-decoration: none;
  }
`

export const PageBottomContent = styled(PageContent)<PageBottomContentProps>`
  margin-top: ${({ $padding }) => ($padding ? '0px' : '24px')};
  display: flex;
  padding: ${({ $padding }) => ($padding ? `${$padding}px` : '0px')};
  flex-direction: column;
  gap: 24px;
  background-color: cornflowerblue;
`

export const ButtonContainer = styled.div<{
  $hasScroll: boolean
  $notFixed?: boolean
}>`
  width: 100vw;
  align-self: center;
  background-color: var(--neutral-theme);
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  ${({ $notFixed }) => ($notFixed ? '' : 'position: fixed; bottom: 0; padding: 1rem 1.25rem;')}
  ${({ $hasScroll }) =>
    $hasScroll
      ? 'border-top: 1px solid var(--gray200);'
      : 'border: 1px solid var(--neutral-theme);'}
`

export const Button = styled(ButtonElement)`
  @media (hover: none) {
    &&:hover:enabled {
      border-color: ${(props) =>
        props.variant === 'primary' || props.variant === undefined
          ? 'var(--primary500)'
          : 'inherit'} !important;
      background-color: ${(props) =>
        props.variant === 'primary' || props.variant === undefined
          ? 'var(--primary500)'
          : 'inherit'} !important;
      transform: none !important;
    }
  }
`
